import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { TableConfig } from '../core/models/table-config.model';
import { PorsantTypePipe } from '../shared/pipes/porsant-type.pipe';
import { AuditService } from '../core/services/audit.service';
import { Router } from '@angular/router';
import * as moment from 'jalali-moment';
import { DashboardService } from '../core/services/dashboard.service';

@Component({
  selector: 'bt-financial',
  templateUrl: './financial.component.html',
  styleUrls: ['./financial.component.scss']
})
export class FinancialComponent implements OnInit {
  loading = true;
  data;
  showFilter = true;
  pageNumber;
  nowDate = new Date();
  form: FormGroup;
  configTable: TableConfig = {
    row: [
      {
        columnDef: 'rowId',
        header: 'ردیف',
        cell: (row) => row.rowId,
        type: 'string',
      }, {
        columnDef: 'value',
        header: 'مبلغ',
        cell: (row) => row.value,
        type: 'price'
      }, {
        columnDef: 'referenceNumber',
        header: 'شماره ارجاع',
        cell: (row) => row.referenceNumber,
      }, {
        columnDef: 'trackingCode',
        header: 'کد پیگیری',
        cell: (row) => row.trackingCode,
        type: 'string'
      }, {
        columnDef: 'bankReferenceNumber',
        header: 'شماره مرجع بانک',
        cell: (row) => row.bankReferenceNumber,
      }, {
        columnDef: 'sourceAccount',
        header: 'حساب مبدا',
        cell: (row) => row.sourceAccount
      }, {
        columnDef: 'destinationAccount',
        header: 'حساب مقصد',
        cell: (row) => row.destinationAccount,
        type: 'string'
      }, {
        columnDef: 'createDate',
        header: 'تاریخ ثبت',
        cell: (row) => row.createDate,
        type: 'date'
      },
    ],
    operaions: [],
    footer: [],
    paginator: {
      itemPerPage: 10,
      client: false
    }
  };
  payload = {
    startDate: '-1',
    endDate: '-1',
    pageSize: '10',
    pageNumber: '1',
  };
  walletAmount;

  constructor(
    private auditService: AuditService,
    private dashboardService: DashboardService,
    private router: Router,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.getData();
    this.createForm();
    this.dashboardService.getWalletAmount().subscribe(
      res => {
        this.walletAmount = res[0]?.wallet;

      }
    );
  }

  search() {
    this.payload.startDate = this.form.value.startDate ?
      moment(new Date(this.form.value.startDate)).format('YYYY-MM-DD') : '-1';
    this.payload.endDate = this.form.value.endDate ?
      moment(new Date(this.form.value.endDate)).format('YYYY-MM-DD') : '-1';
    this.getData();
  }
  createForm() {
    this.form = this.fb.group({
      startDate: '',
      endDate: '',
    });
  }
  pageSelected(event) {
    this.payload.pageNumber = String(event);
    this.getData();
  }
  getData() {
    this.auditService.getPaidSalaryInformation(this.payload).subscribe(
      res => {
        this.data = res.data;
        this.pageNumber = res.pageNumber;
        this.loading = false;

      }
    );
  }

}
